export const tableCustomLoader = () => {

    return  <div style={{ textAlign: 'center', padding: '20px' }}>
                <img src="assets/images/ajax-loaders/ajax-loader-7.gif" alt="Loading..." />
            </div>;
}; 